import React from "react";
import PropTypes from "prop-types";
import HelperContent from "../helperContent/HelperContent";
import QuestionLabel from "./QuestionLabel";
import QuestionOption from "./QuestionOption";
import Footer from "../Footer";

const Question = ({ question = {}, store = {}, selectionMade }) => {
    let options = question.options;
    let optionsCode = null;

    if (options && options.length > 0) {
        optionsCode = (
            <ul className="w3-ul w3-border w3-padding-small w3-margin-top">
                {options.map(option => (
                    <li className="question-option w3-xlarge w3-center" key={option.itemID}>
                        <QuestionOption option={option} onClick={() => selectionMade(option)} />
                    </li>
                ))}
            </ul>
        );
    }

    return (
        <div id="questionRoot" className="form w3-header w3-animate-opacity">
            <QuestionLabel question={question} store={store}/>
            <HelperContent question={question}/>
            <div className="question-options">{optionsCode}</div>
            <Footer question={question}/>
        </div>
    );
};

Question.propTypes = {
    question: PropTypes.object,
    selectionMade: PropTypes.func
};

export default Question;
